import { PopulatedAssessment, TemplateId } from '@hb/shared'
import { useMemo } from 'react'

export const useAssessmentAutoTemplate = (
  assessment: PopulatedAssessment | null,
): TemplateId | null => {
  const { plans: insurancePlans } = assessment ?? {}

  return useMemo(() => {
    const { plan, insuranceProvider } = insurancePlans?.primary ?? {}
    if (plan?.templateId) return { templateId: plan.templateId, practiceId: null }
    if (insuranceProvider?.defaultTemplateId) {
      return { templateId: insuranceProvider.defaultTemplateId, practiceId: null }
    }
    return null
  }, [insurancePlans])
}
